import React, { useState } from "react"
import { useShallow } from "zustand/react/shallow"

// components
import Modal from "components/Modal/Modal"
import Checkbox from "components/Checkbox/Checkbox"
import { FormButtons } from "components-design-system"
import Label from "components/Label/Label"

// hooks
import useAuthoringViewStore from "../../../hooks/stores/useAuthoringViewStore"
import "./ResultsTableCreateModal.scss"

const ResultsTableCreateModal = (props) => {
  const [createForAll, setCreateForAll] = useState(false)
  const [createCategoryCtg, setCreateCategoryCtg] = useState(false)
  const [createRowCtg, setCreateRowCtg] = useState(true)

  let { header, message, showModal, setShowModal, onSubmit, addEudractCategory = false, registrySpecific } = props

  const { formView } = useAuthoringViewStore(
    useShallow((state) => ({
      formView: state.formView,
    }))
  )

  const handleSubmit = async () => {
    setShowModal(false)
    await new Promise((r) => setTimeout(r, 200))
    let all = registrySpecific ? false : true
    if (formView.id === "global")
      onSubmit(all, {
        createCategoryCtg,
        createRowCtg,
      })
    else
      onSubmit(createForAll, {
        createCategoryCtg,
        createRowCtg,
      })
    setCreateForAll(false)
  }

  const displayAdditionalCheckboxes = () => {
    return (
      <>
        <Checkbox
          label={"You are adding a category in EudraCT, when creating in CTG - add as a category"}
          checked={createCategoryCtg}
          onChange={(e) => {
            setCreateCategoryCtg(e.target.checked)
            setCreateRowCtg(!e.target.checked)
          }}
        />
        <Checkbox
          label={"You are adding a category in EudraCT, when creating in CTG - add as a row"}
          checked={createRowCtg}
          onChange={(e) => {
            setCreateCategoryCtg(e.target.checked)
            setCreateRowCtg(!e.target.checked)
          }}
        />
      </>
    )
  }

  let view = formView.id
  if (formView.id === "eudra") view = "eudract"

  return (
    <Modal
      title={header}
      type={"create"}
      open={showModal}
      destroyOnClose={true}
      onCancel={() => setShowModal(false)}
      footer={[]}
    >
      <div>
        {message && <div className="create-group-modal-container">{message}</div>}
        {formView.id === "global" ? (
          <div className="create-group-modal-container">
            Note: If applicable, creating items from Global view will create items for all registries.
          </div>
        ) : (
          <div className="create-group-modal-container">
            {registrySpecific !== true && (
              <Checkbox
                label={`Create for all registries`}
                checked={createForAll}
                onChange={(e) => setCreateForAll(e.target.checked)}
              />
            )}
            {view === "eudract" && addEudractCategory === true && createForAll && displayAdditionalCheckboxes()}
            <Checkbox
              label={`Create for ${view?.toUpperCase()} only`}
              checked={true}
            />
            <br />
            <br />
            <Label>NOTE: If adding only to {view?.toUpperCase()}, this data may not appear in the Global view</Label>
          </div>
        )}
        <div className="create-group-modal-action">
          <FormButtons
            onCancel={() => setShowModal(false)}
            okText="Create"
            onOk={() => handleSubmit()}
          />
        </div>
      </div>
    </Modal>
  )
}

export default ResultsTableCreateModal
